import UnicoUtils from "./script-utils.js";

(function ($) {
  let mobileSlider;
  const duration = 300;


  /**
   * スライダー設定
   */
  function initSlider() {
    if (!mobileSlider) {
      galleryCarousel();
    };
  }

  /**
   * スライダーインスタンスを破棄
   */
  function destroySlider() {
    if (mobileSlider) {
      mobileSlider.destroy();
      mobileSlider = null;
    }
  }

  /**
   * スライダー
   */
  function galleryCarousel() {
    const myOptions = {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      centeredSlides: true,
      slidesPerView: 'auto',
    }

    const mobileSlider = new Swiper('.js-gallery-carousel', myOptions);
  }

  /*
  * アコーディオン
  */
  function toggleInit() {
    if ($('.js-toggle').length) {
      $('.js-toggle').find('.js-toggle-label').each(function () {
        if (!$(this).hasClass('is-opened')) {
          $(this).siblings('.js-toggle-content').hide();
        }
        $(this).on('click', function () {
          if ($('+.js-toggle-content', this).not(':animated').length > 0) {
            $('+.js-toggle-content', this).slideToggle(duration);
            $(this).toggleClass('is-opened');
          }
          return false;
        });
      });
    };
  }

  /*
  * スクロールアニメーション
  */
  const delta = $(window).height() / 1.6;
  function scrollEffect() {
    $('.js-effect').each(function (i) {
      const elemPosition = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      if (scrollTop > elemPosition - delta) {
        $(this).addClass('is-visible');
      } else {
        $(this).removeClass('is-visible');
      }
    });
  }


  /**
   * ready
   */
  $(function() {
    toggleInit();
    initSmoothScroll();
  });

  window.addEventListener('DOMContentLoaded', function() {
    scrollEffect();

    if (UnicoUtils.isSP()) {
      initSlider();
    }
  });


  /**
   * リサイズ処理
   */
  window.addEventListener('resize', function() {
    if (UnicoUtils.isSP()) {
      if (!mobileSlider) {
        initSlider();
      }
    } else {
      if (mobileSlider) {
        destroySlider();
      }
    }
  });

  /**
   * scroll
   */
  $(window).scroll(() => {
    scrollEffect();
  });

  /**
   * アニメーションカクつき対策のためオリジナルのスムーススクロールを実装
   */
  function initSmoothScroll() {
    const galleryList = $(".gallery-list");
    if (galleryList.length > 0) {
      const anchors = document.querySelectorAll('.main a[href^="#"]');
      anchors.forEach((elem) => {
        elem.addEventListener("click", (e) => {
          e.stopImmediatePropagation();
          e.preventDefault();
          const href = $(elem).attr('href');
          $(window).scrollTop($(href).offset().top - $("#header").innerHeight());
        }, true);
      });
    }
  }
})(window.jQuery);